import { UseMutationOptions, useMutation } from 'react-query';
import { AddPoAttachmentPayload, POFileAttachmentResponse } from 'src/queries/PurchaseOrders';
import apiClient from 'src/queries/apiClient';
import { ApiResponseType, responseWrapper } from 'src/queries/helpers';

export function useAddTravelCompletionAttachment(
  options?: UseMutationOptions<
    ApiResponseType<POFileAttachmentResponse>,
    Error,
    AddPoAttachmentPayload
  >
) {
  const {
    mutate: addTravelCompletionAttachment,
    data,
    isLoading,
    isSuccess,
  } = useMutation<ApiResponseType<POFileAttachmentResponse>, Error, AddPoAttachmentPayload>({
    mutationFn: (payload: AddPoAttachmentPayload) =>
      responseWrapper(apiClient.addTravelCompletionAttachment, [payload]),
    ...options,
  });

  return {
    addTravelCompletionAttachment,
    data,
    isLoading,
    isSuccess,
  };
}
